<div class="workflow-progress-bar-container" *ngIf="model.show">
    <button mat-icon-button class="btn-back" *ngIf="model.showButtonBack || returnUrl" (click)="onClick()">
        <mat-icon fontSet="phr-iconset" class="phr-iconset-PHR-Volver"></mat-icon>
    </button>
    <mat-progress-bar mode="determinate" [value]="model.percentComplete" *ngIf="model.showProgressBar"></mat-progress-bar>
    <button mat-icon-button class="btn-close" *ngIf="model.showButtonClose && !returnUrl" (click)="model.closeFn()">
        <mat-icon fontSet="phr-iconset" class="phr-iconset-PHR-Cerrar"></mat-icon>
    </button>
</div>